// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-list-gallery{width:100%}@media (min-width:768px){.h-list-gallery--1{padding:0 180px}}@media (min-width:768px){.h-list-gallery--2{padding:0 80px}}@media (min-width:768px){.h-list-gallery--3{padding:0 60px}}@media (min-width:768px){.h-list-gallery--4{padding:0 20px}}@media (min-width:768px){.h-list-gallery__items{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:10px;gap:10px;-ms-flex-pack:distribute;justify-content:space-around;width:100%}}", ""]);
// Exports
module.exports = exports;
